import { frozen } from "mobx-keystone";
import { createGlobalModel } from "../../lib/models/global-t-model";
import AuthStore from "./store.auth";

export default function createAuthStore(): Promise<AuthStore> {
  return createGlobalModel(AuthStore, {
    token: undefined,
    email: undefined,
    session: frozen(null),
    lastSync: new Date(),
  });
}
